import LineInterface from 'app/interfaces/LineInterface';

export const fullNickMainOrNested = (line: LineInterface, num: number): string => {
    const gamer = line[`gamer_${num}`];
    return gamer.type
        ? `${gamer.game_name ? `${gamer.game_name} ` : ''}${gamer.nick}`
        : gamer.nick;
};
